module.exports = __webpack_public_path__ + "img/wenzi.a31e110a.png";